import { useClipboard } from '../hooks/useClipboard';
import styles from './HackCard.module.css';

const CAT_COLORS = {
  JavaScript: '#f7df1e30',
  React:      '#61dbfb30',
  CSS:        '#ff69b430',
  Git:        '#f0562030',
  TypeScript: '#3178c630',
  Node:       '#3c873a30',
};

export default function HackCard({ hack, dark = false, style = {} }) {
  const { copiedId, copy } = useClipboard();

  return (
    <div
      className={`${styles.card} ${dark ? styles.cardDark : ''}`}
      style={{ animationDelay: style.animationDelay || '0s' }}
    >
      <div className={styles.top}>
        <span
          className={styles.cat}
          style={{ background: CAT_COLORS[hack.category] || '#e8e8e830' }}
        >
          {hack.category}
        </span>
        <button
          className={`${styles.copyBtn} ${copiedId === hack.id ? styles.copied : ''}`}
          onClick={() => copy(hack.id, hack.code)}
        >
          {copiedId === hack.id ? '✓ Copied!' : 'Copy'}
        </button>
      </div>

      <h3 className={`${styles.title} ${dark ? styles.titleDark : ''}`}>
        {hack.title}
      </h3>

      <pre className={styles.code}><code>{hack.code}</code></pre>

      <p className={`${styles.tip} ${dark ? styles.tipDark : ''}`}>
        💡 {hack.tip}
      </p>
    </div>
  );
}
